module.exports = __webpack_public_path__ + "static/media/diktat-5.2e3883ea.mp3";